import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { LoginGuardService } from '../../api/login-guard.service';
import { AuthService } from '../../api/auth.service';

@Component({
  selector: 'ui-trans-accounts',
  templateUrl: './ui-trans-accounts.component.html',
  styleUrls: ['./ui-trans-accounts.component.scss']
})
export class UiTransAccountsComponent implements OnInit {

  form = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(''),
  })

  constructor(
    private loginGuard: LoginGuardService, // 
    private auth:AuthService,
  ) { }

  ngOnInit() {
  }

  createAccount(){
    this.auth.apiCreate('rest/auth/translators', {
      email: this.form.controls.email.value,
      password: this.form.controls.password.value,
    })
    .then(res => {
      console.log('Created user ', res);
      alert('Created user');
    })
    .catch(e => {
      console.error('Failed to create user ', e);
      alert('Failed to create user');
    })
  }

}
